import { useState, useEffect } from 'react';
import EventCard from '../../../UI/EventCard/EventCard';
import { supabase } from '../../../../api';
import { Box, Grid, Typography } from '@mui/material';

// sort based on date
// populate data in supabase

const Body = () => {
  let [events, setEvents] = useState();

  useEffect(
    () => {
      fetchEvents();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const fetchEvents = async () => {
    let { data: events, error } = await supabase.from('events').select('*');
    if (error) console.log(error);
    else setEvents(events);
  };

  if (events === undefined) {
    return <Typography>Still loading...</Typography>;
  }

  return (
    <Box sx={{ mt: '3rem' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: '3rem',
        }}>
        <Grid container alignItems='stretch' sx={{ mt: '3rem' }}>
          {events
            .sort(function (a, b) {
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(b.eventDate) - new Date(a.eventDate);
            })
            .map((event) => {
              return (
                <EventCard
                  key={event.id}
                  eventImage={event.eventImage}
                  eventDate={event.eventDate}
                  eventLink={event.eventLink}
                  eventStatus={event.eventStatus}
                  membersOnly={event.membersOnly}
                  id={event.id}
                />
              );
            })}
        </Grid>
      </Box>
    </Box>
  );
};

export default Body;
